export const costs = [
  'Sleepless nights translating complex automation concepts',
  'Improvised explanations from disorganized technical materials',
  "Disconnected colleagues who don't see automation technology relevance",
  'Weekends building technical references and system analyses from scratch',
  'No clear answers when professionals ask technical questions',
];
